//#region src/pd-icon-picker/emoji-data.ts
var emojiCategories = [
	{
		id: "full-smileys",
		label: "Smileys & Emotion",
		items: [
			{
				emoji: "😀",
				key: "grinning-face",
				tags: "grinning face happy smile grinsen"
			},
			{
				emoji: "😃",
				key: "grinning-big-eyes",
				tags: "grinning big eyes smile happy"
			},
			{
				emoji: "😄",
				key: "grinning-squinting",
				tags: "grinning squinting smile happy lachen"
			},
			{
				emoji: "😁",
				key: "beaming-face",
				tags: "beaming face smile grin strahlen"
			},
			{
				emoji: "😆",
				key: "squinting-face",
				tags: "squinting face laugh lachen xd"
			},
			{
				emoji: "😅",
				key: "sweat-smile",
				tags: "sweat smile grinning nervous schweiss"
			},
			{
				emoji: "🤣",
				key: "rofl",
				tags: "rolling floor laughing rofl lachen"
			},
			{
				emoji: "😂",
				key: "joy",
				tags: "face tears joy laughing lachen freude"
			},
			{
				emoji: "🙂",
				key: "slightly-smiling",
				tags: "slightly smiling face leicht laecheln"
			},
			{
				emoji: "🙃",
				key: "upside-down",
				tags: "upside down face verkehrt ironie sarcasm"
			},
			{
				emoji: "😉",
				key: "winking",
				tags: "winking face zwinkern"
			},
			{
				emoji: "😊",
				key: "smiling-blush",
				tags: "smiling blushing face happy zufrieden"
			},
			{
				emoji: "😇",
				key: "smiling-halo",
				tags: "smiling halo angel engel heilig innocent"
			},
			{
				emoji: "🥰",
				key: "smiling-hearts",
				tags: "smiling hearts love liebe verliebt"
			},
			{
				emoji: "😍",
				key: "heart-eyes",
				tags: "heart eyes love liebe verliebt herz"
			},
			{
				emoji: "🤩",
				key: "star-struck",
				tags: "star struck excited begeistert stars"
			},
			{
				emoji: "😘",
				key: "kissing-heart",
				tags: "kissing heart kuss face blow"
			},
			{
				emoji: "😗",
				key: "kissing",
				tags: "kissing face kuss"
			},
			{
				emoji: "😚",
				key: "kissing-closed",
				tags: "kissing closed eyes kuss"
			},
			{
				emoji: "😙",
				key: "kissing-smiling",
				tags: "kissing smiling eyes kuss"
			},
			{
				emoji: "🥲",
				key: "smiling-tear",
				tags: "smiling tear happy sad traene"
			},
			{
				emoji: "😋",
				key: "yummy",
				tags: "yummy face savoring lecker food"
			},
			{
				emoji: "😛",
				key: "tongue-out",
				tags: "tongue out face zunge"
			},
			{
				emoji: "😜",
				key: "winking-tongue",
				tags: "winking tongue face zunge zwinkern"
			},
			{
				emoji: "🤪",
				key: "zany",
				tags: "zany face crazy verrueckt wild"
			},
			{
				emoji: "😝",
				key: "squinting-tongue",
				tags: "squinting tongue face zunge"
			},
			{
				emoji: "🤑",
				key: "money-face",
				tags: "money mouth face geld dollar rich"
			},
			{
				emoji: "🤗",
				key: "hugging",
				tags: "hugging face hug umarmung"
			},
			{
				emoji: "🤭",
				key: "hand-over-mouth",
				tags: "hand over mouth giggling kichern oops"
			},
			{
				emoji: "🫢",
				key: "open-eyes-hand",
				tags: "open eyes hand mouth surprise"
			},
			{
				emoji: "🫣",
				key: "peeking",
				tags: "peeking face eye peek spaehen"
			},
			{
				emoji: "🤫",
				key: "shushing",
				tags: "shushing face quiet leise pssst secret"
			},
			{
				emoji: "🤔",
				key: "thinking",
				tags: "thinking face denken nachdenken hmm"
			},
			{
				emoji: "🫡",
				key: "saluting",
				tags: "saluting face salute gruss"
			},
			{
				emoji: "🤐",
				key: "zipper-mouth",
				tags: "zipper mouth face schweigen still quiet"
			},
			{
				emoji: "🤨",
				key: "raised-eyebrow",
				tags: "raised eyebrow face skeptisch skeptical"
			},
			{
				emoji: "😐",
				key: "neutral-face",
				tags: "neutral face straight ausdruckslos"
			},
			{
				emoji: "😑",
				key: "expressionless",
				tags: "expressionless face ausdruckslos blank"
			},
			{
				emoji: "😶",
				key: "no-mouth",
				tags: "no mouth face speechless sprachlos"
			},
			{
				emoji: "🫥",
				key: "dotted-line-face",
				tags: "dotted line face invisible unsichtbar"
			},
			{
				emoji: "😏",
				key: "smirking",
				tags: "smirking face smirk grinsen"
			},
			{
				emoji: "😒",
				key: "unamused",
				tags: "unamused face unzufrieden genervt"
			},
			{
				emoji: "🙄",
				key: "eye-roll",
				tags: "rolling eyes face augenrollen whatever"
			},
			{
				emoji: "😬",
				key: "grimacing",
				tags: "grimacing face awkward grimasse"
			},
			{
				emoji: "🫨",
				key: "shaking-face",
				tags: "shaking face vibrating zittern"
			},
			{
				emoji: "😌",
				key: "relieved",
				tags: "relieved face erleichtert peaceful"
			},
			{
				emoji: "😔",
				key: "pensive",
				tags: "pensive face nachdenklich sad traurig"
			},
			{
				emoji: "😪",
				key: "sleepy",
				tags: "sleepy face schlaefrig muede tired"
			},
			{
				emoji: "🤤",
				key: "drooling",
				tags: "drooling face sabbern lecker"
			},
			{
				emoji: "😴",
				key: "sleeping",
				tags: "sleeping face zzz schlafen tired muede"
			},
			{
				emoji: "😷",
				key: "mask",
				tags: "mask face medical maske krank sick"
			},
			{
				emoji: "🤒",
				key: "thermometer",
				tags: "thermometer face sick krank fieber fever"
			},
			{
				emoji: "🤕",
				key: "bandage",
				tags: "bandage head face verletzt injured hurt"
			},
			{
				emoji: "🤢",
				key: "nauseated",
				tags: "nauseated face sick uebel green"
			},
			{
				emoji: "🤮",
				key: "vomiting",
				tags: "vomiting face sick krank"
			},
			{
				emoji: "🥵",
				key: "hot-face",
				tags: "hot face heiss warm heat"
			},
			{
				emoji: "🥶",
				key: "cold-face",
				tags: "cold face kalt freezing frost"
			},
			{
				emoji: "🥴",
				key: "woozy",
				tags: "woozy face dizzy drunk betrunken schwindel"
			},
			{
				emoji: "😵",
				key: "dizzy-face",
				tags: "dizzy face knocked out schwindel"
			},
			{
				emoji: "🤠",
				key: "cowboy",
				tags: "cowboy hat face western"
			},
			{
				emoji: "🥳",
				key: "partying",
				tags: "partying face party feier celebrate"
			},
			{
				emoji: "🥸",
				key: "disguised",
				tags: "disguised face incognito verkleidet"
			},
			{
				emoji: "😎",
				key: "sunglasses",
				tags: "sunglasses face cool sonnenbrille"
			},
			{
				emoji: "🤓",
				key: "nerd",
				tags: "nerd face glasses brille geek"
			},
			{
				emoji: "🧐",
				key: "monocle",
				tags: "monocle face thinking inspecting"
			},
			{
				emoji: "😕",
				key: "confused",
				tags: "confused face verwirrt"
			},
			{
				emoji: "🫤",
				key: "diagonal-mouth",
				tags: "diagonal mouth face unsure meh"
			},
			{
				emoji: "😟",
				key: "worried",
				tags: "worried face besorgt sorge"
			},
			{
				emoji: "🙁",
				key: "slightly-frowning",
				tags: "slightly frowning face traurig sad"
			},
			{
				emoji: "😮",
				key: "open-mouth",
				tags: "open mouth face surprise ueberraschung"
			},
			{
				emoji: "😯",
				key: "hushed",
				tags: "hushed face quiet surprise still"
			},
			{
				emoji: "😲",
				key: "astonished",
				tags: "astonished face surprise shock erstaunt"
			},
			{
				emoji: "😳",
				key: "flushed",
				tags: "flushed face embarrassed rot verlegen"
			},
			{
				emoji: "🥺",
				key: "pleading",
				tags: "pleading face puppy eyes bitte please"
			},
			{
				emoji: "🥹",
				key: "holding-back-tears",
				tags: "holding back tears emotional geruehrt"
			},
			{
				emoji: "😦",
				key: "frowning-open",
				tags: "frowning open mouth face"
			},
			{
				emoji: "😧",
				key: "anguished",
				tags: "anguished face verzweifelt"
			},
			{
				emoji: "😨",
				key: "fearful",
				tags: "fearful face angst scared afraid"
			},
			{
				emoji: "😰",
				key: "anxious-sweat",
				tags: "anxious sweat face nervoes angst"
			},
			{
				emoji: "😥",
				key: "sad-relieved",
				tags: "sad relieved face disappointed"
			},
			{
				emoji: "😢",
				key: "crying",
				tags: "crying face weinen traene sad"
			},
			{
				emoji: "😭",
				key: "loudly-crying",
				tags: "loudly crying face weinen sob"
			},
			{
				emoji: "😱",
				key: "screaming",
				tags: "screaming face fear shock scream"
			},
			{
				emoji: "😖",
				key: "confounded",
				tags: "confounded face frustrated frustriert"
			},
			{
				emoji: "😣",
				key: "persevering",
				tags: "persevering face struggle anstrengung"
			},
			{
				emoji: "😞",
				key: "disappointed",
				tags: "disappointed face sad enttaeuscht"
			},
			{
				emoji: "😓",
				key: "downcast-sweat",
				tags: "downcast sweat face sad"
			},
			{
				emoji: "😩",
				key: "weary",
				tags: "weary face tired muede erschoepft"
			},
			{
				emoji: "😫",
				key: "tired-face",
				tags: "tired face exhausted muede"
			},
			{
				emoji: "🥱",
				key: "yawning",
				tags: "yawning face tired muede gaehnen"
			},
			{
				emoji: "😤",
				key: "huffing",
				tags: "huffing face steam angry wuetend"
			},
			{
				emoji: "😡",
				key: "angry",
				tags: "angry face pouting wuetend zornig"
			},
			{
				emoji: "😠",
				key: "angry-face",
				tags: "angry face mad boese wuetend"
			},
			{
				emoji: "🤬",
				key: "swearing",
				tags: "swearing face cursing symbols fluchen"
			},
			{
				emoji: "😈",
				key: "devil-smile",
				tags: "devil smile face horns teufel"
			},
			{
				emoji: "👿",
				key: "devil-angry",
				tags: "devil angry face imp teufel"
			},
			{
				emoji: "💀",
				key: "skull",
				tags: "skull death totenkopf dead"
			},
			{
				emoji: "☠️",
				key: "skull-crossbones",
				tags: "skull crossbones danger gefahr gift"
			},
			{
				emoji: "💋",
				key: "kiss-mark",
				tags: "kiss mark lips kuss lippen"
			},
			{
				emoji: "💌",
				key: "love-letter",
				tags: "love letter liebesbrief heart"
			},
			{
				emoji: "💘",
				key: "heart-arrow",
				tags: "heart arrow cupid amor liebe"
			},
			{
				emoji: "💝",
				key: "heart-ribbon",
				tags: "heart ribbon gift geschenk liebe"
			},
			{
				emoji: "💖",
				key: "sparkling-heart",
				tags: "sparkling heart glitzer liebe love"
			},
			{
				emoji: "💗",
				key: "growing-heart",
				tags: "growing heart liebe love"
			},
			{
				emoji: "💓",
				key: "beating-heart",
				tags: "beating heart liebe love puls"
			},
			{
				emoji: "💞",
				key: "revolving-hearts",
				tags: "revolving hearts liebe love"
			},
			{
				emoji: "💕",
				key: "two-hearts",
				tags: "two hearts liebe love herzen"
			},
			{
				emoji: "❣️",
				key: "heart-exclamation",
				tags: "heart exclamation liebe love"
			},
			{
				emoji: "💔",
				key: "broken-heart",
				tags: "broken heart gebrochen traurig"
			},
			{
				emoji: "🩷",
				key: "pink-heart",
				tags: "pink heart rosa herz liebe"
			},
			{
				emoji: "🧡",
				key: "orange-heart",
				tags: "orange heart herz liebe"
			},
			{
				emoji: "💛",
				key: "yellow-heart",
				tags: "yellow heart gelb herz liebe"
			},
			{
				emoji: "💚",
				key: "green-heart",
				tags: "green heart gruen herz liebe"
			},
			{
				emoji: "💙",
				key: "blue-heart",
				tags: "blue heart blau herz liebe"
			},
			{
				emoji: "🩵",
				key: "light-blue-heart",
				tags: "light blue heart hellblau herz"
			},
			{
				emoji: "💜",
				key: "purple-heart",
				tags: "purple heart lila herz liebe"
			},
			{
				emoji: "🖤",
				key: "black-heart",
				tags: "black heart schwarz herz"
			},
			{
				emoji: "🩶",
				key: "grey-heart",
				tags: "grey heart grau herz"
			},
			{
				emoji: "🤍",
				key: "white-heart",
				tags: "white heart weiss herz"
			},
			{
				emoji: "🤎",
				key: "brown-heart",
				tags: "brown heart braun herz"
			},
			{
				emoji: "💯",
				key: "full-hundred",
				tags: "hundred points perfect perfekt score"
			},
			{
				emoji: "💢",
				key: "anger-symbol",
				tags: "anger symbol wut zorn"
			},
			{
				emoji: "💥",
				key: "collision",
				tags: "collision boom explosion crash"
			},
			{
				emoji: "💫",
				key: "dizzy-star",
				tags: "dizzy star schwindel sparkle"
			},
			{
				emoji: "💦",
				key: "sweat-droplets",
				tags: "sweat droplets water wasser schweiss"
			},
			{
				emoji: "💨",
				key: "dashing",
				tags: "dashing away wind schnell fast"
			},
			{
				emoji: "🕳️",
				key: "hole",
				tags: "hole loch"
			},
			{
				emoji: "💤",
				key: "zzz",
				tags: "zzz sleeping schlafen muede"
			},
			{
				emoji: "💬",
				key: "speech-balloon",
				tags: "speech balloon sprechblase chat dialog"
			},
			{
				emoji: "💭",
				key: "thought-balloon",
				tags: "thought balloon denken gedanke thinking"
			}
		]
	},
	{
		id: "full-people",
		label: "People & Body",
		items: [
			{
				emoji: "👋",
				key: "full-wave",
				tags: "waving hand hello hallo tschuess bye winken"
			},
			{
				emoji: "🤚",
				key: "raised-back",
				tags: "raised back hand stop halt"
			},
			{
				emoji: "🖐️",
				key: "hand-fingers",
				tags: "hand splayed fingers five fuenf"
			},
			{
				emoji: "✋",
				key: "raised-hand",
				tags: "raised hand stop halt high five"
			},
			{
				emoji: "🖖",
				key: "vulcan",
				tags: "vulcan salute spock star trek"
			},
			{
				emoji: "🫱",
				key: "rightward-hand",
				tags: "rightward hand rechts"
			},
			{
				emoji: "🫲",
				key: "leftward-hand",
				tags: "leftward hand links"
			},
			{
				emoji: "👌",
				key: "ok-hand",
				tags: "ok hand perfect gut okay"
			},
			{
				emoji: "🤌",
				key: "pinched-fingers",
				tags: "pinched fingers italian perfetto"
			},
			{
				emoji: "🤏",
				key: "pinching",
				tags: "pinching hand small klein bisschen"
			},
			{
				emoji: "✌️",
				key: "victory",
				tags: "victory hand peace frieden two zwei"
			},
			{
				emoji: "🤞",
				key: "crossed-fingers",
				tags: "crossed fingers luck glueck hope"
			},
			{
				emoji: "🫰",
				key: "hand-index-thumb",
				tags: "hand index thumb money geld snap"
			},
			{
				emoji: "🤟",
				key: "love-you",
				tags: "love you gesture ily liebe"
			},
			{
				emoji: "🤘",
				key: "rock-on",
				tags: "rock on sign horns metal rock"
			},
			{
				emoji: "🤙",
				key: "call-me",
				tags: "call me hand phone hang loose"
			},
			{
				emoji: "👈",
				key: "pointing-left",
				tags: "pointing left finger links zeigen"
			},
			{
				emoji: "👉",
				key: "pointing-right",
				tags: "pointing right finger rechts zeigen"
			},
			{
				emoji: "👆",
				key: "pointing-up",
				tags: "pointing up finger oben zeigen"
			},
			{
				emoji: "👇",
				key: "pointing-down",
				tags: "pointing down finger unten zeigen"
			},
			{
				emoji: "☝️",
				key: "index-up",
				tags: "index pointing up finger zeigefinger"
			},
			{
				emoji: "🫵",
				key: "pointing-viewer",
				tags: "index pointing viewer you du"
			},
			{
				emoji: "👍",
				key: "full-thumbsup",
				tags: "thumbs up like gut daumen hoch"
			},
			{
				emoji: "👎",
				key: "thumbsdown",
				tags: "thumbs down dislike schlecht daumen runter"
			},
			{
				emoji: "✊",
				key: "raised-fist",
				tags: "raised fist power faust kraft"
			},
			{
				emoji: "👊",
				key: "fist-bump",
				tags: "fist bump punch faust schlag"
			},
			{
				emoji: "🤛",
				key: "left-fist",
				tags: "left fist bump faust links"
			},
			{
				emoji: "🤜",
				key: "right-fist",
				tags: "right fist bump faust rechts"
			},
			{
				emoji: "👏",
				key: "clapping",
				tags: "clapping hands applause klatschen bravo"
			},
			{
				emoji: "🙌",
				key: "full-raised-hands",
				tags: "raising hands hooray celebrate feier"
			},
			{
				emoji: "🫶",
				key: "heart-hands",
				tags: "heart hands love liebe herz"
			},
			{
				emoji: "👐",
				key: "open-hands",
				tags: "open hands jazz hug offen"
			},
			{
				emoji: "🤲",
				key: "palms-up",
				tags: "palms up together pray beten"
			},
			{
				emoji: "🤝",
				key: "full-handshake",
				tags: "handshake deal agreement handschlag"
			},
			{
				emoji: "🙏",
				key: "folded-hands",
				tags: "folded hands pray please bitte danke thanks beten"
			},
			{
				emoji: "✍️",
				key: "writing-hand",
				tags: "writing hand schreiben sign"
			},
			{
				emoji: "💅",
				key: "nail-polish",
				tags: "nail polish nails naegel beauty"
			},
			{
				emoji: "🤳",
				key: "selfie",
				tags: "selfie phone foto"
			},
			{
				emoji: "💪",
				key: "full-muscle",
				tags: "flexed biceps muscle strong kraft stark arm"
			},
			{
				emoji: "🦾",
				key: "mechanical-arm",
				tags: "mechanical arm prosthetic robot"
			},
			{
				emoji: "🧠",
				key: "brain",
				tags: "brain gehirn smart intelligent denken"
			},
			{
				emoji: "👀",
				key: "eyes",
				tags: "eyes looking augen schauen blick"
			},
			{
				emoji: "👁️",
				key: "single-eye",
				tags: "eye auge sehen"
			},
			{
				emoji: "👅",
				key: "tongue",
				tags: "tongue zunge taste"
			},
			{
				emoji: "👄",
				key: "mouth",
				tags: "mouth lips mund lippen"
			},
			{
				emoji: "👶",
				key: "baby",
				tags: "baby infant kind"
			},
			{
				emoji: "🧒",
				key: "child",
				tags: "child kind jung young"
			},
			{
				emoji: "👦",
				key: "boy",
				tags: "boy junge male"
			},
			{
				emoji: "👧",
				key: "girl",
				tags: "girl maedchen female"
			},
			{
				emoji: "🧑",
				key: "adult",
				tags: "adult person erwachsener"
			},
			{
				emoji: "👨",
				key: "man",
				tags: "man mann male maennlich"
			},
			{
				emoji: "👩",
				key: "woman",
				tags: "woman frau female weiblich"
			},
			{
				emoji: "🧓",
				key: "older-person",
				tags: "older person senior aelter"
			},
			{
				emoji: "👴",
				key: "old-man",
				tags: "old man grandfather opa grossvater"
			},
			{
				emoji: "👵",
				key: "old-woman",
				tags: "old woman grandmother oma grossmutter"
			},
			{
				emoji: "👤",
				key: "full-bust-silhouette",
				tags: "bust silhouette person user"
			},
			{
				emoji: "👥",
				key: "full-busts-silhouette",
				tags: "busts silhouette people group team"
			},
			{
				emoji: "🧑‍💻",
				key: "full-technologist",
				tags: "technologist developer coder programmer entwickler"
			},
			{
				emoji: "🧑‍💼",
				key: "full-office-worker",
				tags: "office worker business buero angestellter"
			},
			{
				emoji: "🧑‍🔬",
				key: "scientist",
				tags: "scientist wissenschaftler research forschung"
			},
			{
				emoji: "🧑‍🎨",
				key: "artist",
				tags: "artist kuenstler creative design"
			},
			{
				emoji: "🧑‍🏫",
				key: "teacher",
				tags: "teacher lehrer education bildung"
			},
			{
				emoji: "🧑‍🎓",
				key: "full-student",
				tags: "student graduate absolvent bildung"
			},
			{
				emoji: "🧑‍⚕️",
				key: "health-worker",
				tags: "health worker doctor arzt medizin"
			},
			{
				emoji: "🧑‍🍳",
				key: "cook",
				tags: "cook chef koch kochen"
			},
			{
				emoji: "🧑‍🔧",
				key: "mechanic",
				tags: "mechanic handwerker techniker repair"
			},
			{
				emoji: "🧑‍🚀",
				key: "astronaut",
				tags: "astronaut space weltraum rakete"
			},
			{
				emoji: "🧑‍🚒",
				key: "firefighter",
				tags: "firefighter feuerwehr fire"
			},
			{
				emoji: "👮",
				key: "police",
				tags: "police officer polizist law"
			},
			{
				emoji: "🕵️",
				key: "detective",
				tags: "detective spy detektiv agent"
			},
			{
				emoji: "💂",
				key: "guard",
				tags: "guard wache soldat"
			},
			{
				emoji: "🥷",
				key: "ninja",
				tags: "ninja stealth hidden"
			},
			{
				emoji: "🧙",
				key: "mage",
				tags: "mage wizard zauberer magic"
			},
			{
				emoji: "🦸",
				key: "superhero",
				tags: "superhero hero held cape"
			},
			{
				emoji: "🦹",
				key: "supervillain",
				tags: "supervillain villain boesewicht"
			}
		]
	},
	{
		id: "full-animals",
		label: "Animals & Nature",
		items: [
			{
				emoji: "🐶",
				key: "dog-face",
				tags: "dog face hund welpe puppy"
			},
			{
				emoji: "🐱",
				key: "cat-face",
				tags: "cat face katze kitten"
			},
			{
				emoji: "🐭",
				key: "mouse-face",
				tags: "mouse face maus"
			},
			{
				emoji: "🐹",
				key: "hamster",
				tags: "hamster face"
			},
			{
				emoji: "🐰",
				key: "rabbit-face",
				tags: "rabbit face hase bunny"
			},
			{
				emoji: "🦊",
				key: "fox",
				tags: "fox face fuchs"
			},
			{
				emoji: "🐻",
				key: "bear",
				tags: "bear face baer"
			},
			{
				emoji: "🐼",
				key: "panda",
				tags: "panda face"
			},
			{
				emoji: "🐨",
				key: "koala",
				tags: "koala face"
			},
			{
				emoji: "🐯",
				key: "tiger-face",
				tags: "tiger face"
			},
			{
				emoji: "🦁",
				key: "lion",
				tags: "lion face loewe"
			},
			{
				emoji: "🐮",
				key: "cow-face",
				tags: "cow face kuh"
			},
			{
				emoji: "🐷",
				key: "pig-face",
				tags: "pig face schwein"
			},
			{
				emoji: "🐸",
				key: "frog",
				tags: "frog face frosch"
			},
			{
				emoji: "🐵",
				key: "monkey-face",
				tags: "monkey face affe"
			},
			{
				emoji: "🙈",
				key: "see-no-evil",
				tags: "see no evil monkey nicht sehen"
			},
			{
				emoji: "🙉",
				key: "hear-no-evil",
				tags: "hear no evil monkey nicht hoeren"
			},
			{
				emoji: "🙊",
				key: "speak-no-evil",
				tags: "speak no evil monkey nicht sprechen"
			},
			{
				emoji: "🐔",
				key: "chicken",
				tags: "chicken huhn henne"
			},
			{
				emoji: "🐧",
				key: "penguin",
				tags: "penguin pinguin"
			},
			{
				emoji: "🐦",
				key: "bird",
				tags: "bird vogel"
			},
			{
				emoji: "🦅",
				key: "eagle",
				tags: "eagle adler"
			},
			{
				emoji: "🦆",
				key: "duck",
				tags: "duck ente"
			},
			{
				emoji: "🦉",
				key: "owl",
				tags: "owl eule wise"
			},
			{
				emoji: "🦇",
				key: "bat",
				tags: "bat fledermaus"
			},
			{
				emoji: "🐺",
				key: "wolf",
				tags: "wolf face"
			},
			{
				emoji: "🐗",
				key: "boar",
				tags: "boar wildschwein"
			},
			{
				emoji: "🐴",
				key: "horse-face",
				tags: "horse face pferd"
			},
			{
				emoji: "🦄",
				key: "unicorn",
				tags: "unicorn einhorn magic fantasy"
			},
			{
				emoji: "🐝",
				key: "bee",
				tags: "bee honeybee biene honig"
			},
			{
				emoji: "🪲",
				key: "beetle",
				tags: "beetle kaefer bug"
			},
			{
				emoji: "🐛",
				key: "bug",
				tags: "bug caterpillar raupe insekt"
			},
			{
				emoji: "🦋",
				key: "butterfly",
				tags: "butterfly schmetterling"
			},
			{
				emoji: "🐌",
				key: "snail",
				tags: "snail schnecke slow langsam"
			},
			{
				emoji: "🐙",
				key: "octopus",
				tags: "octopus krake tintenfisch"
			},
			{
				emoji: "🐠",
				key: "tropical-fish",
				tags: "tropical fish fisch"
			},
			{
				emoji: "🐟",
				key: "fish",
				tags: "fish fisch"
			},
			{
				emoji: "🐬",
				key: "dolphin",
				tags: "dolphin delfin"
			},
			{
				emoji: "🐳",
				key: "whale",
				tags: "whale wal spouting"
			},
			{
				emoji: "🦈",
				key: "shark",
				tags: "shark hai"
			},
			{
				emoji: "🐊",
				key: "crocodile",
				tags: "crocodile krokodil"
			},
			{
				emoji: "🐢",
				key: "turtle",
				tags: "turtle schildkroete slow langsam"
			},
			{
				emoji: "🦎",
				key: "lizard",
				tags: "lizard eidechse"
			},
			{
				emoji: "🐍",
				key: "snake",
				tags: "snake schlange"
			},
			{
				emoji: "🦂",
				key: "scorpion",
				tags: "scorpion skorpion"
			},
			{
				emoji: "💐",
				key: "bouquet",
				tags: "bouquet flowers blumen strauss"
			},
			{
				emoji: "🌸",
				key: "full-blossom",
				tags: "cherry blossom kirschbluete fruehling spring"
			},
			{
				emoji: "🌹",
				key: "rose",
				tags: "rose blume flower rot red"
			},
			{
				emoji: "🌺",
				key: "hibiscus",
				tags: "hibiscus flower blume"
			},
			{
				emoji: "🌻",
				key: "sunflower",
				tags: "sunflower sonnenblume"
			},
			{
				emoji: "🌼",
				key: "blossom-yellow",
				tags: "blossom flower blume"
			},
			{
				emoji: "🌷",
				key: "tulip",
				tags: "tulip tulpe blume flower"
			},
			{
				emoji: "🌱",
				key: "full-seedling",
				tags: "seedling sprout pflanze wachstum growth"
			},
			{
				emoji: "🪴",
				key: "potted-plant",
				tags: "potted plant topfpflanze zimmerpflanze"
			},
			{
				emoji: "🌲",
				key: "evergreen",
				tags: "evergreen tree nadelbaum tanne christmas"
			},
			{
				emoji: "🌳",
				key: "full-deciduous-tree",
				tags: "deciduous tree laubbaum baum"
			},
			{
				emoji: "🌴",
				key: "palm-tree",
				tags: "palm tree palme tropical"
			},
			{
				emoji: "🌵",
				key: "cactus",
				tags: "cactus kaktus desert wueste"
			},
			{
				emoji: "🍀",
				key: "full-four-leaf",
				tags: "four leaf clover kleeblatt glueck luck"
			},
			{
				emoji: "🍁",
				key: "maple-leaf",
				tags: "maple leaf ahorn herbst autumn canada"
			},
			{
				emoji: "🍂",
				key: "fallen-leaf",
				tags: "fallen leaf herbst autumn blatt"
			},
			{
				emoji: "🍃",
				key: "leaf-wind",
				tags: "leaf fluttering wind blatt natur"
			},
			{
				emoji: "🌍",
				key: "full-globe-europe",
				tags: "globe europe africa erde welt world global"
			},
			{
				emoji: "🌎",
				key: "globe-americas",
				tags: "globe americas erde welt world america"
			},
			{
				emoji: "🌏",
				key: "globe-asia",
				tags: "globe asia australia erde welt world asien"
			},
			{
				emoji: "🌑",
				key: "new-moon",
				tags: "new moon neumond dunkel"
			},
			{
				emoji: "🌕",
				key: "full-moon",
				tags: "full moon vollmond"
			},
			{
				emoji: "🌙",
				key: "crescent-moon",
				tags: "crescent moon mond nacht night"
			},
			{
				emoji: "⭐",
				key: "full-star",
				tags: "star stern favorit"
			},
			{
				emoji: "🌟",
				key: "glowing-star",
				tags: "glowing star stern leuchtend"
			},
			{
				emoji: "✨",
				key: "full-sparkles",
				tags: "sparkles glitzer magic clean new"
			},
			{
				emoji: "⚡",
				key: "full-high-voltage",
				tags: "high voltage lightning blitz energy"
			},
			{
				emoji: "🔥",
				key: "full-fire",
				tags: "fire feuer hot heiss trend popular"
			},
			{
				emoji: "🌈",
				key: "rainbow",
				tags: "rainbow regenbogen farben diversity"
			},
			{
				emoji: "☀️",
				key: "full-sun",
				tags: "sun sonne wetter weather warm"
			},
			{
				emoji: "🌤️",
				key: "sun-small-cloud",
				tags: "sun small cloud sonne wolke"
			},
			{
				emoji: "⛅",
				key: "sun-behind-cloud",
				tags: "sun behind cloud sonne wolke"
			},
			{
				emoji: "🌧️",
				key: "cloud-rain",
				tags: "cloud rain regen wolke"
			},
			{
				emoji: "⛈️",
				key: "cloud-lightning",
				tags: "cloud lightning rain gewitter thunder"
			},
			{
				emoji: "🌩️",
				key: "cloud-lightning-only",
				tags: "cloud lightning blitz"
			},
			{
				emoji: "❄️",
				key: "snowflake",
				tags: "snowflake schneeflocke winter cold kalt"
			},
			{
				emoji: "☃️",
				key: "snowman",
				tags: "snowman schneemann winter"
			},
			{
				emoji: "🌊",
				key: "full-wave-water",
				tags: "water wave welle meer sea ocean tsunami"
			},
			{
				emoji: "🌪️",
				key: "tornado",
				tags: "tornado wirbelsturm storm"
			},
			{
				emoji: "🌫️",
				key: "fog",
				tags: "fog nebel mist"
			}
		]
	},
	{
		id: "full-food",
		label: "Food & Drink",
		items: [
			{
				emoji: "🍎",
				key: "red-apple",
				tags: "red apple apfel rot fruit obst"
			},
			{
				emoji: "🍊",
				key: "tangerine",
				tags: "tangerine orange mandarine fruit obst"
			},
			{
				emoji: "🍋",
				key: "lemon",
				tags: "lemon zitrone fruit obst"
			},
			{
				emoji: "🍌",
				key: "banana",
				tags: "banana banane fruit obst"
			},
			{
				emoji: "🍉",
				key: "watermelon",
				tags: "watermelon wassermelone fruit obst"
			},
			{
				emoji: "🍇",
				key: "grapes",
				tags: "grapes trauben weintrauben fruit obst"
			},
			{
				emoji: "🍓",
				key: "strawberry",
				tags: "strawberry erdbeere fruit obst"
			},
			{
				emoji: "🫐",
				key: "blueberries",
				tags: "blueberries blaubeeren heidelbeeren"
			},
			{
				emoji: "🍑",
				key: "peach",
				tags: "peach pfirsich fruit obst"
			},
			{
				emoji: "🍒",
				key: "cherries",
				tags: "cherries kirschen fruit obst"
			},
			{
				emoji: "🥝",
				key: "kiwi",
				tags: "kiwi fruit obst"
			},
			{
				emoji: "🍅",
				key: "tomato",
				tags: "tomato tomate gemuese vegetable"
			},
			{
				emoji: "🥑",
				key: "avocado",
				tags: "avocado guacamole healthy gesund"
			},
			{
				emoji: "🥦",
				key: "broccoli",
				tags: "broccoli brokkoli gemuese vegetable healthy"
			},
			{
				emoji: "🥕",
				key: "carrot",
				tags: "carrot karotte moehre gemuese"
			},
			{
				emoji: "🌽",
				key: "corn",
				tags: "corn mais"
			},
			{
				emoji: "🌶️",
				key: "hot-pepper",
				tags: "hot pepper chili scharf spicy"
			},
			{
				emoji: "🥒",
				key: "cucumber",
				tags: "cucumber gurke"
			},
			{
				emoji: "🧄",
				key: "garlic",
				tags: "garlic knoblauch"
			},
			{
				emoji: "🧅",
				key: "onion",
				tags: "onion zwiebel"
			},
			{
				emoji: "🥐",
				key: "croissant",
				tags: "croissant french breakfast fruehstueck"
			},
			{
				emoji: "🍞",
				key: "bread",
				tags: "bread brot loaf"
			},
			{
				emoji: "🥖",
				key: "baguette",
				tags: "baguette french bread brot"
			},
			{
				emoji: "🥨",
				key: "pretzel",
				tags: "pretzel brezel"
			},
			{
				emoji: "🧀",
				key: "cheese",
				tags: "cheese kaese"
			},
			{
				emoji: "🍳",
				key: "cooking-egg",
				tags: "cooking egg fried breakfast ei"
			},
			{
				emoji: "🥞",
				key: "pancakes",
				tags: "pancakes pfannkuchen breakfast"
			},
			{
				emoji: "🧇",
				key: "waffle",
				tags: "waffle waffel breakfast"
			},
			{
				emoji: "🥩",
				key: "cut-meat",
				tags: "cut meat steak fleisch"
			},
			{
				emoji: "🍗",
				key: "poultry-leg",
				tags: "poultry leg chicken haehnchen"
			},
			{
				emoji: "🍔",
				key: "hamburger",
				tags: "hamburger burger fast food"
			},
			{
				emoji: "🍟",
				key: "french-fries",
				tags: "french fries pommes chips"
			},
			{
				emoji: "🍕",
				key: "full-pizza",
				tags: "pizza slice"
			},
			{
				emoji: "🌭",
				key: "hot-dog",
				tags: "hot dog wurst sausage"
			},
			{
				emoji: "🥪",
				key: "sandwich",
				tags: "sandwich belegtes brot"
			},
			{
				emoji: "🌮",
				key: "taco",
				tags: "taco mexican mexikanisch"
			},
			{
				emoji: "🌯",
				key: "burrito",
				tags: "burrito wrap mexican"
			},
			{
				emoji: "🥗",
				key: "salad",
				tags: "salad salat green healthy gesund"
			},
			{
				emoji: "🍝",
				key: "spaghetti",
				tags: "spaghetti pasta nudeln italian"
			},
			{
				emoji: "🍜",
				key: "ramen",
				tags: "ramen noodles nudeln soup suppe"
			},
			{
				emoji: "🍲",
				key: "pot-food",
				tags: "pot food stew eintopf kochen"
			},
			{
				emoji: "🍱",
				key: "bento",
				tags: "bento box japanese lunch"
			},
			{
				emoji: "🍣",
				key: "sushi",
				tags: "sushi japanese fish fisch"
			},
			{
				emoji: "🍙",
				key: "rice-ball",
				tags: "rice ball onigiri reis"
			},
			{
				emoji: "🍰",
				key: "shortcake",
				tags: "shortcake cake kuchen dessert"
			},
			{
				emoji: "🎂",
				key: "full-birthday-cake",
				tags: "birthday cake geburtstag torte"
			},
			{
				emoji: "🧁",
				key: "cupcake",
				tags: "cupcake muffin dessert sweet"
			},
			{
				emoji: "🍫",
				key: "chocolate",
				tags: "chocolate bar schokolade"
			},
			{
				emoji: "🍬",
				key: "candy",
				tags: "candy bonbon suess sweet"
			},
			{
				emoji: "🍭",
				key: "lollipop",
				tags: "lollipop lolli suess sweet"
			},
			{
				emoji: "🍩",
				key: "doughnut",
				tags: "doughnut donut suess sweet"
			},
			{
				emoji: "🍪",
				key: "cookie",
				tags: "cookie keks"
			},
			{
				emoji: "🍦",
				key: "ice-cream",
				tags: "ice cream eis soft serve"
			},
			{
				emoji: "☕",
				key: "full-coffee",
				tags: "coffee hot kaffee heiss tee tea"
			},
			{
				emoji: "🍵",
				key: "tea",
				tags: "tea tee cup green"
			},
			{
				emoji: "🫖",
				key: "teapot",
				tags: "teapot teekanne"
			},
			{
				emoji: "🧃",
				key: "juice-box",
				tags: "juice box saft"
			},
			{
				emoji: "🥤",
				key: "cup-straw",
				tags: "cup straw drink getraenk soda"
			},
			{
				emoji: "🧋",
				key: "bubble-tea",
				tags: "bubble tea boba"
			},
			{
				emoji: "🍺",
				key: "beer-mug",
				tags: "beer mug bier krug prost"
			},
			{
				emoji: "🍻",
				key: "clinking-beers",
				tags: "clinking beer mugs bier anstossen prost"
			},
			{
				emoji: "🥂",
				key: "full-champagne",
				tags: "clinking glasses champagner sekt anstossen prost feier"
			},
			{
				emoji: "🍷",
				key: "wine-glass",
				tags: "wine glass wein rot red"
			},
			{
				emoji: "🍸",
				key: "cocktail",
				tags: "cocktail martini drink mixed"
			},
			{
				emoji: "🍹",
				key: "tropical-drink",
				tags: "tropical drink cocktail"
			},
			{
				emoji: "🧊",
				key: "ice",
				tags: "ice cube eis wuerfel cold kalt"
			},
			{
				emoji: "🍽️",
				key: "full-fork-knife-plate",
				tags: "fork knife plate teller besteck restaurant dining essen"
			}
		]
	},
	{
		id: "full-travel",
		label: "Travel & Places",
		items: [
			{
				emoji: "🚗",
				key: "car",
				tags: "car auto automobile fahren drive"
			},
			{
				emoji: "🚕",
				key: "taxi",
				tags: "taxi cab auto"
			},
			{
				emoji: "🚌",
				key: "bus",
				tags: "bus oepnv transit"
			},
			{
				emoji: "🚎",
				key: "trolleybus",
				tags: "trolleybus bus"
			},
			{
				emoji: "🚐",
				key: "minibus",
				tags: "minibus van transporter"
			},
			{
				emoji: "🚑",
				key: "ambulance",
				tags: "ambulance krankenwagen emergency"
			},
			{
				emoji: "🚒",
				key: "fire-engine",
				tags: "fire engine feuerwehr"
			},
			{
				emoji: "🚓",
				key: "police-car",
				tags: "police car polizei"
			},
			{
				emoji: "🚲",
				key: "bicycle",
				tags: "bicycle fahrrad bike rad"
			},
			{
				emoji: "🛵",
				key: "scooter",
				tags: "motor scooter roller"
			},
			{
				emoji: "🏍️",
				key: "motorcycle",
				tags: "motorcycle motorrad"
			},
			{
				emoji: "✈️",
				key: "airplane",
				tags: "airplane flugzeug fliegen fly travel"
			},
			{
				emoji: "🚀",
				key: "full-rocket",
				tags: "rocket rakete space launch start"
			},
			{
				emoji: "🛸",
				key: "ufo",
				tags: "flying saucer ufo alien space"
			},
			{
				emoji: "🚁",
				key: "helicopter",
				tags: "helicopter hubschrauber"
			},
			{
				emoji: "🚢",
				key: "ship",
				tags: "ship schiff cruise kreuzfahrt boat"
			},
			{
				emoji: "⛵",
				key: "sailboat",
				tags: "sailboat segelboot boot"
			},
			{
				emoji: "🚂",
				key: "locomotive",
				tags: "locomotive lokomotive train zug"
			},
			{
				emoji: "🚆",
				key: "train",
				tags: "train zug bahn"
			},
			{
				emoji: "🚇",
				key: "metro",
				tags: "metro subway ubahn underground"
			},
			{
				emoji: "⛽",
				key: "fuel-pump",
				tags: "fuel pump tankstelle benzin gas"
			},
			{
				emoji: "🚦",
				key: "traffic-light",
				tags: "traffic light ampel"
			},
			{
				emoji: "🗺️",
				key: "world-map",
				tags: "world map weltkarte reise travel"
			},
			{
				emoji: "🗿",
				key: "moai",
				tags: "moai statue easter island"
			},
			{
				emoji: "🗽",
				key: "statue-liberty",
				tags: "statue liberty freiheitsstatue new york"
			},
			{
				emoji: "🏰",
				key: "castle",
				tags: "castle schloss burg"
			},
			{
				emoji: "🏯",
				key: "japanese-castle",
				tags: "japanese castle schloss"
			},
			{
				emoji: "🏟️",
				key: "stadium",
				tags: "stadium stadion sport"
			},
			{
				emoji: "🏠",
				key: "full-house",
				tags: "house building haus gebaeude home"
			},
			{
				emoji: "🏡",
				key: "house-garden",
				tags: "house garden haus garten"
			},
			{
				emoji: "🏢",
				key: "full-office-building",
				tags: "office building buero gebaeude firma"
			},
			{
				emoji: "🏣",
				key: "post-office",
				tags: "post office postamt"
			},
			{
				emoji: "🏥",
				key: "full-hospital",
				tags: "hospital krankenhaus gesundheit health"
			},
			{
				emoji: "🏦",
				key: "bank",
				tags: "bank geld money finance finanzen"
			},
			{
				emoji: "🏨",
				key: "hotel",
				tags: "hotel uebernachtung accommodation"
			},
			{
				emoji: "🏩",
				key: "love-hotel",
				tags: "love hotel"
			},
			{
				emoji: "🏪",
				key: "full-convenience-store",
				tags: "convenience store laden geschaeft shop"
			},
			{
				emoji: "🏫",
				key: "school",
				tags: "school schule bildung education"
			},
			{
				emoji: "🏬",
				key: "department-store",
				tags: "department store kaufhaus einkaufen"
			},
			{
				emoji: "🏭",
				key: "factory",
				tags: "factory fabrik industrie production"
			},
			{
				emoji: "🏗️",
				key: "full-construction",
				tags: "construction building crane baustelle bau kran"
			},
			{
				emoji: "⛺",
				key: "tent",
				tags: "tent zelt camping outdoor"
			},
			{
				emoji: "🏔️",
				key: "full-snow-mountain",
				tags: "snow mountain berg schnee gipfel peak"
			},
			{
				emoji: "⛰️",
				key: "mountain",
				tags: "mountain berg"
			},
			{
				emoji: "🏝️",
				key: "desert-island",
				tags: "desert island insel palm tropical"
			},
			{
				emoji: "🏖️",
				key: "beach",
				tags: "beach strand umbrella schirm sommer"
			},
			{
				emoji: "📍",
				key: "full-pin",
				tags: "pin round pushpin ort standort location marker"
			}
		]
	},
	{
		id: "full-activities",
		label: "Activities",
		items: [
			{
				emoji: "🎃",
				key: "jack-o-lantern",
				tags: "jack o lantern pumpkin kuerbis halloween"
			},
			{
				emoji: "🎄",
				key: "christmas-tree",
				tags: "christmas tree weihnachtsbaum xmas"
			},
			{
				emoji: "🎆",
				key: "fireworks",
				tags: "fireworks feuerwerk silvester new year"
			},
			{
				emoji: "🎇",
				key: "sparkler",
				tags: "sparkler wunderkerze"
			},
			{
				emoji: "🧨",
				key: "firecracker",
				tags: "firecracker knaller boeller"
			},
			{
				emoji: "✨",
				key: "full-sparkles-act",
				tags: "sparkles glitzer clean new magic"
			},
			{
				emoji: "🎈",
				key: "balloon",
				tags: "balloon luftballon party feier"
			},
			{
				emoji: "🎉",
				key: "full-party-popper",
				tags: "party popper feier celebration confetti"
			},
			{
				emoji: "🎊",
				key: "confetti-ball",
				tags: "confetti ball feier celebration"
			},
			{
				emoji: "🎋",
				key: "tanabata-tree",
				tags: "tanabata tree wish wunsch"
			},
			{
				emoji: "🎍",
				key: "pine-decoration",
				tags: "pine decoration new year"
			},
			{
				emoji: "🎎",
				key: "dolls",
				tags: "japanese dolls puppen"
			},
			{
				emoji: "🎏",
				key: "carp-streamer",
				tags: "carp streamer japanese koi"
			},
			{
				emoji: "🎐",
				key: "wind-chime",
				tags: "wind chime windspiel"
			},
			{
				emoji: "🎑",
				key: "moon-viewing",
				tags: "moon viewing ceremony mond"
			},
			{
				emoji: "🧧",
				key: "red-envelope",
				tags: "red envelope lucky money glueck"
			},
			{
				emoji: "🎀",
				key: "ribbon",
				tags: "ribbon schleife gift geschenk"
			},
			{
				emoji: "🎁",
				key: "gift-box",
				tags: "gift wrapped present geschenk paket"
			},
			{
				emoji: "🎗️",
				key: "reminder-ribbon",
				tags: "reminder ribbon awareness band"
			},
			{
				emoji: "🎟️",
				key: "admission-ticket",
				tags: "admission ticket eintrittskarte event"
			},
			{
				emoji: "🎫",
				key: "ticket",
				tags: "ticket karte event"
			},
			{
				emoji: "🎖️",
				key: "military-medal",
				tags: "military medal medaille auszeichnung"
			},
			{
				emoji: "🏆",
				key: "full-trophy",
				tags: "trophy pokal winner gewinner award preis"
			},
			{
				emoji: "🏅",
				key: "sports-medal",
				tags: "sports medal medaille"
			},
			{
				emoji: "🥇",
				key: "gold-medal",
				tags: "gold medal first platz eins"
			},
			{
				emoji: "🥈",
				key: "silver-medal",
				tags: "silver medal second platz zwei"
			},
			{
				emoji: "🥉",
				key: "bronze-medal",
				tags: "bronze medal third platz drei"
			},
			{
				emoji: "⚽",
				key: "soccer",
				tags: "soccer ball fussball football"
			},
			{
				emoji: "🏀",
				key: "basketball",
				tags: "basketball"
			},
			{
				emoji: "🏈",
				key: "american-football",
				tags: "american football"
			},
			{
				emoji: "⚾",
				key: "baseball",
				tags: "baseball"
			},
			{
				emoji: "🥎",
				key: "softball",
				tags: "softball"
			},
			{
				emoji: "🎾",
				key: "tennis",
				tags: "tennis ball"
			},
			{
				emoji: "🏐",
				key: "volleyball",
				tags: "volleyball"
			},
			{
				emoji: "🏓",
				key: "table-tennis",
				tags: "ping pong table tennis tischtennis"
			},
			{
				emoji: "🥊",
				key: "boxing",
				tags: "boxing glove boxen kampf"
			},
			{
				emoji: "🎯",
				key: "full-bullseye",
				tags: "bullseye direct hit target ziel treffer dartboard"
			},
			{
				emoji: "⛳",
				key: "golf",
				tags: "flag hole golf"
			},
			{
				emoji: "🎳",
				key: "bowling",
				tags: "bowling"
			},
			{
				emoji: "🎮",
				key: "full-video-game",
				tags: "video game controller spielen gaming"
			},
			{
				emoji: "🎲",
				key: "dice",
				tags: "game die dice wuerfel zufall random"
			},
			{
				emoji: "🧩",
				key: "full-puzzle",
				tags: "puzzle piece raetsel loesung solution"
			},
			{
				emoji: "♟️",
				key: "chess-pawn",
				tags: "chess pawn schach bauer strategy"
			},
			{
				emoji: "🎭",
				key: "performing-arts",
				tags: "performing arts theater drama maske"
			},
			{
				emoji: "🎨",
				key: "full-artist-palette",
				tags: "artist palette kunst art malen paint farbe color"
			},
			{
				emoji: "🎵",
				key: "full-musical-note",
				tags: "musical note musik sound ton"
			},
			{
				emoji: "🎶",
				key: "musical-notes",
				tags: "musical notes musik sound toene"
			},
			{
				emoji: "🎤",
				key: "microphone",
				tags: "microphone mikrofon singing singen karaoke"
			},
			{
				emoji: "🎧",
				key: "headphone",
				tags: "headphone kopfhoerer music musik audio"
			},
			{
				emoji: "🎸",
				key: "guitar",
				tags: "guitar gitarre music musik rock"
			},
			{
				emoji: "🎹",
				key: "musical-keyboard",
				tags: "musical keyboard piano klavier"
			},
			{
				emoji: "🥁",
				key: "drum",
				tags: "drum trommel music musik"
			},
			{
				emoji: "🎬",
				key: "clapper-board",
				tags: "clapper board film movie kino"
			},
			{
				emoji: "🎪",
				key: "circus-tent",
				tags: "circus tent zirkus zelt"
			},
			{
				emoji: "🎓",
				key: "full-graduation-cap",
				tags: "graduation cap mortarboard abschluss studium bildung"
			},
			{
				emoji: "📸",
				key: "full-camera-flash",
				tags: "camera flash kamera foto photo bild picture"
			}
		]
	},
	{
		id: "full-objects",
		label: "Objects",
		items: [
			{
				emoji: "⌚",
				key: "watch",
				tags: "watch uhr armbanduhr zeit time"
			},
			{
				emoji: "📱",
				key: "full-mobile-phone",
				tags: "mobile phone handy smartphone telefon"
			},
			{
				emoji: "📲",
				key: "mobile-arrow",
				tags: "mobile phone arrow incoming eingehend"
			},
			{
				emoji: "💻",
				key: "full-laptop",
				tags: "laptop computer rechner notebook"
			},
			{
				emoji: "🖥️",
				key: "desktop",
				tags: "desktop computer bildschirm monitor pc"
			},
			{
				emoji: "🖨️",
				key: "printer",
				tags: "printer drucker"
			},
			{
				emoji: "⌨️",
				key: "keyboard",
				tags: "keyboard tastatur typing"
			},
			{
				emoji: "🖱️",
				key: "computer-mouse",
				tags: "computer mouse maus"
			},
			{
				emoji: "💾",
				key: "floppy-disk",
				tags: "floppy disk diskette save speichern"
			},
			{
				emoji: "💿",
				key: "optical-disk",
				tags: "optical disk cd dvd"
			},
			{
				emoji: "📀",
				key: "dvd",
				tags: "dvd disk"
			},
			{
				emoji: "📡",
				key: "satellite-antenna",
				tags: "satellite antenna dish satellit antenne signal"
			},
			{
				emoji: "🔋",
				key: "battery",
				tags: "battery batterie akku power"
			},
			{
				emoji: "🔌",
				key: "electric-plug",
				tags: "electric plug stecker strom power"
			},
			{
				emoji: "💡",
				key: "full-light-bulb",
				tags: "light bulb idea idee gluehbirne lampe innovation"
			},
			{
				emoji: "🔦",
				key: "flashlight",
				tags: "flashlight taschenlampe light licht"
			},
			{
				emoji: "📷",
				key: "camera",
				tags: "camera kamera foto photo"
			},
			{
				emoji: "📹",
				key: "video-camera",
				tags: "video camera videokamera film"
			},
			{
				emoji: "🎥",
				key: "movie-camera",
				tags: "movie camera filmkamera kino"
			},
			{
				emoji: "📺",
				key: "television",
				tags: "television tv fernseher"
			},
			{
				emoji: "📻",
				key: "radio",
				tags: "radio"
			},
			{
				emoji: "📞",
				key: "full-telephone-receiver",
				tags: "telephone receiver telefon hoerer call anruf"
			},
			{
				emoji: "☎️",
				key: "telephone",
				tags: "telephone telefon old alt"
			},
			{
				emoji: "📟",
				key: "pager",
				tags: "pager piepser"
			},
			{
				emoji: "📠",
				key: "fax",
				tags: "fax machine faxgeraet"
			},
			{
				emoji: "🔔",
				key: "bell",
				tags: "bell glocke notification benachrichtigung"
			},
			{
				emoji: "🔕",
				key: "no-bell",
				tags: "bell slash no notification mute stumm"
			},
			{
				emoji: "📢",
				key: "loudspeaker",
				tags: "loudspeaker megaphone lautsprecher announcement"
			},
			{
				emoji: "📣",
				key: "megaphone",
				tags: "megaphone cheering horn"
			},
			{
				emoji: "🔈",
				key: "speaker-low",
				tags: "speaker low volume lautsprecher leise"
			},
			{
				emoji: "🔊",
				key: "speaker-high",
				tags: "speaker high volume lautsprecher laut"
			},
			{
				emoji: "🔇",
				key: "speaker-muted",
				tags: "muted speaker stumm stille"
			},
			{
				emoji: "⏰",
				key: "full-alarm-clock",
				tags: "alarm clock wecker zeit time morgen"
			},
			{
				emoji: "⏱️",
				key: "full-stopwatch",
				tags: "stopwatch stoppuhr timer"
			},
			{
				emoji: "⏳",
				key: "full-hourglass-flow",
				tags: "hourglass flowing sanduhr zeit time"
			},
			{
				emoji: "🕐",
				key: "full-one-oclock",
				tags: "clock one uhr eins zeit time"
			},
			{
				emoji: "📅",
				key: "full-calendar-date",
				tags: "calendar kalender datum date termin schedule"
			},
			{
				emoji: "📆",
				key: "full-tear-off-calendar",
				tags: "tear off calendar kalender datum"
			},
			{
				emoji: "📇",
				key: "card-index",
				tags: "card index kartei register"
			},
			{
				emoji: "📈",
				key: "full-chart-increasing",
				tags: "chart increasing up wachstum growth trend anstieg"
			},
			{
				emoji: "📉",
				key: "chart-decreasing",
				tags: "chart decreasing down rueckgang decline"
			},
			{
				emoji: "📊",
				key: "full-bar-chart",
				tags: "bar chart statistik statistics diagramm graph"
			},
			{
				emoji: "📋",
				key: "full-clipboard",
				tags: "clipboard klemmbrett liste list aufgaben"
			},
			{
				emoji: "📌",
				key: "pushpin",
				tags: "pushpin pin nadel heften"
			},
			{
				emoji: "📍",
				key: "full-round-pushpin",
				tags: "round pushpin pin ort location standort"
			},
			{
				emoji: "📎",
				key: "full-paperclip",
				tags: "paperclip bueroklammer attachment anhang"
			},
			{
				emoji: "🖇️",
				key: "linked-paperclips",
				tags: "linked paperclips bueroklammern verbunden"
			},
			{
				emoji: "📏",
				key: "ruler",
				tags: "straight ruler lineal messen measure"
			},
			{
				emoji: "📐",
				key: "triangle-ruler",
				tags: "triangular ruler geodreieck"
			},
			{
				emoji: "✂️",
				key: "scissors",
				tags: "scissors schere cut schneiden"
			},
			{
				emoji: "🗂️",
				key: "full-card-dividers",
				tags: "card index dividers ordner register folder"
			},
			{
				emoji: "🗃️",
				key: "card-file-box",
				tags: "card file box karteikasten archiv"
			},
			{
				emoji: "🗄️",
				key: "file-cabinet",
				tags: "file cabinet aktenschrank archiv buero"
			},
			{
				emoji: "🗑️",
				key: "wastebasket",
				tags: "wastebasket muelleimer trash delete papierkorb"
			},
			{
				emoji: "🔒",
				key: "full-locked",
				tags: "locked padlock schloss gesperrt sicher secure"
			},
			{
				emoji: "🔓",
				key: "full-unlocked",
				tags: "unlocked open offen entsperrt"
			},
			{
				emoji: "🔏",
				key: "lock-pen",
				tags: "lock with ink pen signatur"
			},
			{
				emoji: "🔐",
				key: "lock-key",
				tags: "locked with key schluessel sicher"
			},
			{
				emoji: "🔑",
				key: "full-key",
				tags: "key schluessel zugang access"
			},
			{
				emoji: "🛠️",
				key: "full-hammer-wrench",
				tags: "hammer wrench tools werkzeug reparatur service"
			},
			{
				emoji: "⚙️",
				key: "gear",
				tags: "gear zahnrad settings einstellungen mechanik"
			},
			{
				emoji: "🔧",
				key: "wrench",
				tags: "wrench schraubenschluessel werkzeug tool fix"
			},
			{
				emoji: "🔨",
				key: "hammer",
				tags: "hammer werkzeug tool bau build"
			},
			{
				emoji: "🪛",
				key: "screwdriver",
				tags: "screwdriver schraubendreher werkzeug tool"
			},
			{
				emoji: "🔩",
				key: "nut-bolt",
				tags: "nut bolt schraube mutter"
			},
			{
				emoji: "⛓️",
				key: "chains",
				tags: "chains ketten link verbindung"
			},
			{
				emoji: "🧲",
				key: "magnet",
				tags: "magnet anziehung attraction"
			},
			{
				emoji: "🔬",
				key: "microscope",
				tags: "microscope mikroskop forschung research science"
			},
			{
				emoji: "🔭",
				key: "telescope",
				tags: "telescope teleskop astronomie stars"
			},
			{
				emoji: "💉",
				key: "syringe",
				tags: "syringe spritze impfung vaccination medical"
			},
			{
				emoji: "💊",
				key: "pill",
				tags: "pill tablette medikament medicine"
			},
			{
				emoji: "🩹",
				key: "bandage-adhesive",
				tags: "adhesive bandage pflaster"
			},
			{
				emoji: "🧪",
				key: "test-tube",
				tags: "test tube reagenzglas labor lab science"
			},
			{
				emoji: "📝",
				key: "full-memo",
				tags: "memo notiz note schreiben write edit"
			},
			{
				emoji: "📖",
				key: "open-book",
				tags: "open book buch lesen read"
			},
			{
				emoji: "📚",
				key: "books",
				tags: "books buecher bibliothek library stack"
			},
			{
				emoji: "📓",
				key: "notebook",
				tags: "notebook notizbuch journal"
			},
			{
				emoji: "📕",
				key: "closed-book",
				tags: "closed book buch rot"
			},
			{
				emoji: "📧",
				key: "full-e-mail",
				tags: "e-mail email post nachricht message"
			},
			{
				emoji: "📨",
				key: "incoming-envelope",
				tags: "incoming envelope brief eingehend"
			},
			{
				emoji: "📩",
				key: "envelope-arrow",
				tags: "envelope arrow down brief senden"
			},
			{
				emoji: "📬",
				key: "open-mailbox",
				tags: "open mailbox briefkasten post mail"
			},
			{
				emoji: "📮",
				key: "postbox",
				tags: "postbox briefkasten"
			},
			{
				emoji: "📦",
				key: "full-package",
				tags: "package paket box lieferung delivery versand"
			},
			{
				emoji: "🏷️",
				key: "full-label",
				tags: "label tag etikett preis price schild"
			},
			{
				emoji: "💰",
				key: "money-bag",
				tags: "money bag geldsack dollar reich rich"
			},
			{
				emoji: "💳",
				key: "credit-card",
				tags: "credit card kreditkarte bezahlen payment"
			},
			{
				emoji: "💵",
				key: "dollar-bill",
				tags: "dollar bill banknote geld money"
			},
			{
				emoji: "💶",
				key: "euro-bill",
				tags: "euro banknote geld money"
			},
			{
				emoji: "💷",
				key: "pound-bill",
				tags: "pound banknote geld money"
			},
			{
				emoji: "💸",
				key: "money-wings",
				tags: "money with wings geld fliegt ausgaben spending"
			},
			{
				emoji: "🪙",
				key: "coin",
				tags: "coin muenze geld money"
			},
			{
				emoji: "🧾",
				key: "receipt",
				tags: "receipt quittung beleg rechnung invoice"
			}
		]
	},
	{
		id: "full-symbols",
		label: "Symbols",
		items: [
			{
				emoji: "❤️",
				key: "full-red-heart",
				tags: "red heart herz rot liebe love"
			},
			{
				emoji: "🔴",
				key: "red-circle",
				tags: "red circle rot kreis"
			},
			{
				emoji: "🟠",
				key: "orange-circle",
				tags: "orange circle kreis"
			},
			{
				emoji: "🟡",
				key: "yellow-circle",
				tags: "yellow circle gelb kreis"
			},
			{
				emoji: "🟢",
				key: "green-circle",
				tags: "green circle gruen kreis"
			},
			{
				emoji: "🔵",
				key: "blue-circle",
				tags: "blue circle blau kreis"
			},
			{
				emoji: "🟣",
				key: "purple-circle",
				tags: "purple circle lila kreis"
			},
			{
				emoji: "🟤",
				key: "brown-circle",
				tags: "brown circle braun kreis"
			},
			{
				emoji: "⚫",
				key: "black-circle",
				tags: "black circle schwarz kreis"
			},
			{
				emoji: "⚪",
				key: "white-circle",
				tags: "white circle weiss kreis"
			},
			{
				emoji: "🟥",
				key: "red-square",
				tags: "red square rot quadrat"
			},
			{
				emoji: "🟧",
				key: "orange-square",
				tags: "orange square quadrat"
			},
			{
				emoji: "🟨",
				key: "yellow-square",
				tags: "yellow square gelb quadrat"
			},
			{
				emoji: "🟩",
				key: "green-square",
				tags: "green square gruen quadrat"
			},
			{
				emoji: "🟦",
				key: "blue-square",
				tags: "blue square blau quadrat"
			},
			{
				emoji: "🟪",
				key: "purple-square",
				tags: "purple square lila quadrat"
			},
			{
				emoji: "🟫",
				key: "brown-square",
				tags: "brown square braun quadrat"
			},
			{
				emoji: "⬛",
				key: "black-large-square",
				tags: "black large square schwarz"
			},
			{
				emoji: "⬜",
				key: "white-large-square",
				tags: "white large square weiss"
			},
			{
				emoji: "🔶",
				key: "orange-diamond-lg",
				tags: "large orange diamond raute"
			},
			{
				emoji: "🔷",
				key: "blue-diamond-lg",
				tags: "large blue diamond raute"
			},
			{
				emoji: "🔸",
				key: "orange-diamond-sm",
				tags: "small orange diamond raute"
			},
			{
				emoji: "🔹",
				key: "blue-diamond-sm",
				tags: "small blue diamond raute"
			},
			{
				emoji: "🔺",
				key: "red-triangle-up",
				tags: "red triangle pointed up dreieck"
			},
			{
				emoji: "🔻",
				key: "red-triangle-down",
				tags: "red triangle pointed down dreieck"
			},
			{
				emoji: "💠",
				key: "diamond-dot",
				tags: "diamond with dot raute punkt"
			},
			{
				emoji: "✅",
				key: "full-check-mark-box",
				tags: "check mark button done erledigt fertig success"
			},
			{
				emoji: "☑️",
				key: "check-box",
				tags: "check box with check ballot haken"
			},
			{
				emoji: "✔️",
				key: "check-mark",
				tags: "check mark haken done erledigt"
			},
			{
				emoji: "❌",
				key: "full-cross-mark",
				tags: "cross mark kreuz nein no cancel fehler error"
			},
			{
				emoji: "❎",
				key: "cross-mark-button",
				tags: "cross mark button nein no"
			},
			{
				emoji: "➕",
				key: "plus",
				tags: "plus add hinzufuegen neu new"
			},
			{
				emoji: "➖",
				key: "minus",
				tags: "minus subtract entfernen remove"
			},
			{
				emoji: "➗",
				key: "divide",
				tags: "divide division teilen"
			},
			{
				emoji: "✖️",
				key: "multiply",
				tags: "multiply multiplication mal"
			},
			{
				emoji: "♾️",
				key: "infinity",
				tags: "infinity unendlich endlos"
			},
			{
				emoji: "‼️",
				key: "double-exclamation",
				tags: "double exclamation mark ausrufezeichen wichtig important"
			},
			{
				emoji: "⁉️",
				key: "exclamation-question",
				tags: "exclamation question mark frage"
			},
			{
				emoji: "❓",
				key: "question-mark",
				tags: "question mark red fragezeichen rot"
			},
			{
				emoji: "❔",
				key: "question-mark-white",
				tags: "question mark white fragezeichen weiss"
			},
			{
				emoji: "❗",
				key: "exclamation-mark",
				tags: "exclamation mark red ausrufezeichen rot wichtig"
			},
			{
				emoji: "❕",
				key: "exclamation-mark-white",
				tags: "exclamation mark white ausrufezeichen weiss"
			},
			{
				emoji: "〰️",
				key: "wavy-dash",
				tags: "wavy dash welle tilde"
			},
			{
				emoji: "💱",
				key: "currency-exchange",
				tags: "currency exchange waehrung wechsel devisen"
			},
			{
				emoji: "💲",
				key: "dollar-sign",
				tags: "heavy dollar sign geld money preis price"
			},
			{
				emoji: "⚕️",
				key: "medical-symbol",
				tags: "medical symbol medizin gesundheit health"
			},
			{
				emoji: "♻️",
				key: "full-recycling",
				tags: "recycling symbol nachhaltigkeit sustainability umwelt"
			},
			{
				emoji: "⚜️",
				key: "fleur-de-lis",
				tags: "fleur de lis lilie symbol"
			},
			{
				emoji: "🔱",
				key: "trident",
				tags: "trident emblem dreizack"
			},
			{
				emoji: "🔰",
				key: "beginner",
				tags: "japanese symbol beginner anfaenger"
			},
			{
				emoji: "⭕",
				key: "hollow-red-circle",
				tags: "hollow red circle kreis ring"
			},
			{
				emoji: "ℹ️",
				key: "full-information",
				tags: "information source info hinweis"
			},
			{
				emoji: "Ⓜ️",
				key: "circled-m",
				tags: "circled m metro"
			},
			{
				emoji: "🆕",
				key: "new-button",
				tags: "new button neu squared"
			},
			{
				emoji: "🆗",
				key: "ok-button",
				tags: "ok button okay squared"
			},
			{
				emoji: "🆙",
				key: "up-button",
				tags: "up button hoch squared"
			},
			{
				emoji: "🆒",
				key: "cool-button",
				tags: "cool button squared"
			},
			{
				emoji: "🆓",
				key: "free-button",
				tags: "free button kostenlos gratis squared"
			},
			{
				emoji: "🔤",
				key: "abc",
				tags: "abc input latin buchstaben letters alphabet"
			},
			{
				emoji: "🔢",
				key: "numbers-input",
				tags: "input numbers zahlen nummern"
			},
			{
				emoji: "#️⃣",
				key: "hash-key",
				tags: "hash key hashtag raute"
			},
			{
				emoji: "*️⃣",
				key: "asterisk-key",
				tags: "keycap asterisk stern star"
			},
			{
				emoji: "0️⃣",
				key: "keycap-0",
				tags: "keycap zero null"
			},
			{
				emoji: "1️⃣",
				key: "keycap-1",
				tags: "keycap one eins"
			},
			{
				emoji: "2️⃣",
				key: "keycap-2",
				tags: "keycap two zwei"
			},
			{
				emoji: "3️⃣",
				key: "keycap-3",
				tags: "keycap three drei"
			},
			{
				emoji: "4️⃣",
				key: "keycap-4",
				tags: "keycap four vier"
			},
			{
				emoji: "5️⃣",
				key: "keycap-5",
				tags: "keycap five fuenf"
			},
			{
				emoji: "6️⃣",
				key: "keycap-6",
				tags: "keycap six sechs"
			},
			{
				emoji: "7️⃣",
				key: "keycap-7",
				tags: "keycap seven sieben"
			},
			{
				emoji: "8️⃣",
				key: "keycap-8",
				tags: "keycap eight acht"
			},
			{
				emoji: "9️⃣",
				key: "keycap-9",
				tags: "keycap nine neun"
			},
			{
				emoji: "🔟",
				key: "keycap-10",
				tags: "keycap ten zehn"
			},
			{
				emoji: "🏁",
				key: "chequered-flag",
				tags: "chequered flag finish ziel racing rennen"
			},
			{
				emoji: "🚩",
				key: "triangular-flag",
				tags: "triangular flag flagge post"
			},
			{
				emoji: "🎌",
				key: "crossed-flags",
				tags: "crossed flags flaggen"
			},
			{
				emoji: "🏴",
				key: "black-flag",
				tags: "black flag schwarz flagge"
			},
			{
				emoji: "🏳️",
				key: "white-flag",
				tags: "white flag weiss flagge"
			},
			{
				emoji: "🏳️‍🌈",
				key: "rainbow-flag",
				tags: "rainbow flag regenbogen pride lgbtq"
			},
			{
				emoji: "➡️",
				key: "full-right-arrow",
				tags: "right arrow pfeil rechts weiter next"
			},
			{
				emoji: "⬅️",
				key: "left-arrow",
				tags: "left arrow pfeil links zurueck back"
			},
			{
				emoji: "⬆️",
				key: "full-up-arrow",
				tags: "up arrow pfeil hoch oben"
			},
			{
				emoji: "⬇️",
				key: "down-arrow",
				tags: "down arrow pfeil unten runter"
			},
			{
				emoji: "↗️",
				key: "up-right-arrow",
				tags: "up right arrow pfeil nordost"
			},
			{
				emoji: "↘️",
				key: "down-right-arrow",
				tags: "down right arrow pfeil suedost"
			},
			{
				emoji: "↙️",
				key: "down-left-arrow",
				tags: "down left arrow pfeil suedwest"
			},
			{
				emoji: "↖️",
				key: "up-left-arrow",
				tags: "up left arrow pfeil nordwest"
			},
			{
				emoji: "↩️",
				key: "right-hook-arrow",
				tags: "right arrow curving left zurueck back undo"
			},
			{
				emoji: "↪️",
				key: "left-hook-arrow",
				tags: "left arrow curving right redo weiter"
			},
			{
				emoji: "🔄",
				key: "full-counterclockwise",
				tags: "counterclockwise arrows refresh aktualisieren reload sync"
			},
			{
				emoji: "🔃",
				key: "clockwise",
				tags: "clockwise arrows rotate drehen"
			},
			{
				emoji: "🔀",
				key: "shuffle",
				tags: "shuffle tracks mischen zufall random"
			},
			{
				emoji: "🔁",
				key: "repeat",
				tags: "repeat button wiederholen loop"
			},
			{
				emoji: "🔂",
				key: "repeat-single",
				tags: "repeat single button einmal"
			},
			{
				emoji: "▶️",
				key: "play",
				tags: "play button abspielen start"
			},
			{
				emoji: "⏸️",
				key: "pause",
				tags: "pause button anhalten"
			},
			{
				emoji: "⏹️",
				key: "stop-button",
				tags: "stop button stopp halt"
			},
			{
				emoji: "⏺️",
				key: "record",
				tags: "record button aufnehmen"
			},
			{
				emoji: "⏭️",
				key: "next-track",
				tags: "next track button weiter vor"
			},
			{
				emoji: "⏮️",
				key: "previous-track",
				tags: "last track button zurueck"
			},
			{
				emoji: "🔼",
				key: "upward-button",
				tags: "upward button hoch oben"
			},
			{
				emoji: "🔽",
				key: "downward-button",
				tags: "downward button runter unten"
			},
			{
				emoji: "💎",
				key: "full-gem-stone",
				tags: "gem stone diamant juwel premium wertvoll quality"
			},
			{
				emoji: "🔗",
				key: "link-chain",
				tags: "link chain kette verbindung url href"
			},
			{
				emoji: "🪧",
				key: "placard",
				tags: "placard schild sign board"
			}
		]
	},
	{
		id: "full-flags",
		label: "Flags",
		items: [
			{
				emoji: "🇩🇪",
				key: "flag-de",
				tags: "flag germany deutschland german"
			},
			{
				emoji: "🇦🇹",
				key: "flag-at",
				tags: "flag austria oesterreich austrian"
			},
			{
				emoji: "🇨🇭",
				key: "flag-ch",
				tags: "flag switzerland schweiz swiss"
			},
			{
				emoji: "🇬🇧",
				key: "flag-gb",
				tags: "flag united kingdom uk grossbritannien british"
			},
			{
				emoji: "🇺🇸",
				key: "flag-us",
				tags: "flag united states usa amerika american"
			},
			{
				emoji: "🇫🇷",
				key: "flag-fr",
				tags: "flag france frankreich french"
			},
			{
				emoji: "🇮🇹",
				key: "flag-it",
				tags: "flag italy italien italian"
			},
			{
				emoji: "🇪🇸",
				key: "flag-es",
				tags: "flag spain spanien spanish"
			},
			{
				emoji: "🇵🇹",
				key: "flag-pt",
				tags: "flag portugal portuguese"
			},
			{
				emoji: "🇳🇱",
				key: "flag-nl",
				tags: "flag netherlands niederlande dutch"
			},
			{
				emoji: "🇧🇪",
				key: "flag-be",
				tags: "flag belgium belgien belgian"
			},
			{
				emoji: "🇱🇺",
				key: "flag-lu",
				tags: "flag luxembourg luxemburg"
			},
			{
				emoji: "🇵🇱",
				key: "flag-pl",
				tags: "flag poland polen polish"
			},
			{
				emoji: "🇨🇿",
				key: "flag-cz",
				tags: "flag czech republic tschechien"
			},
			{
				emoji: "🇸🇪",
				key: "flag-se",
				tags: "flag sweden schweden swedish"
			},
			{
				emoji: "🇳🇴",
				key: "flag-no",
				tags: "flag norway norwegen norwegian"
			},
			{
				emoji: "🇩🇰",
				key: "flag-dk",
				tags: "flag denmark daenemark danish"
			},
			{
				emoji: "🇫🇮",
				key: "flag-fi",
				tags: "flag finland finnland finnish"
			},
			{
				emoji: "🇬🇷",
				key: "flag-gr",
				tags: "flag greece griechenland greek"
			},
			{
				emoji: "🇹🇷",
				key: "flag-tr",
				tags: "flag turkey tuerkei turkish"
			},
			{
				emoji: "🇷🇺",
				key: "flag-ru",
				tags: "flag russia russland russian"
			},
			{
				emoji: "🇺🇦",
				key: "flag-ua",
				tags: "flag ukraine ukrainian"
			},
			{
				emoji: "🇯🇵",
				key: "flag-jp",
				tags: "flag japan japanese"
			},
			{
				emoji: "🇨🇳",
				key: "flag-cn",
				tags: "flag china chinese"
			},
			{
				emoji: "🇰🇷",
				key: "flag-kr",
				tags: "flag south korea suedkorea korean"
			},
			{
				emoji: "🇮🇳",
				key: "flag-in",
				tags: "flag india indien indian"
			},
			{
				emoji: "🇧🇷",
				key: "flag-br",
				tags: "flag brazil brasilien brazilian"
			},
			{
				emoji: "🇲🇽",
				key: "flag-mx",
				tags: "flag mexico mexiko mexican"
			},
			{
				emoji: "🇨🇦",
				key: "flag-ca",
				tags: "flag canada kanada canadian"
			},
			{
				emoji: "🇦🇺",
				key: "flag-au",
				tags: "flag australia australien australian"
			},
			{
				emoji: "🏴‍☠️",
				key: "pirate-flag",
				tags: "pirate flag piraten jolly roger"
			},
			{
				emoji: "🇪🇺",
				key: "flag-eu",
				tags: "flag european union eu europa"
			}
		]
	}
];
//#endregion
export { emojiCategories };
